import axios from 'axios';

export interface GenerateTokenResponse {
  token: string;
}


/**
 * LiveKit API Service
 * Handles API calls to LiveKit endpoints
 */
class LiveKitApiService {
  /**
   * Generate an access token for joining a location's LiveKit room
   */
  async generateToken(
    serverUrl: string,
    locationId: string,
    authToken: string,
    participantName: string,
    canPublish: boolean = false,
    hidden: boolean = true,
  ): Promise<string> {
    try {
      const response = await axios.post<GenerateTokenResponse>(
        `${serverUrl}/api/livekit/location/${locationId}/token`,
        {
          participantName,
          canPublish,
          hidden,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.data.token) {
        throw new Error('No token received from server');
      }

      return response.data.token;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to generate LiveKit token';
      throw new Error(errorMessage);
    }
  }

}

// Export singleton instance
export const livekitApiService = new LiveKitApiService();
export default livekitApiService;

